
<template>
    <vTableSimple class="margin-15" style="overflow:hidden;height:initial;" border stripe :data="data" :columns="columns"></vTableSimple>
</template>
<script>
//测算结果
export default {
    props:{
        data:{
			type:Array,
			default(){
				return []
			}
		},
		coltype:{
			type:String
		}
    },
    computed:{
        getExpandColumns(){
			return [{
				title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
				key: "costName",
			},{
				title: this.$t('fbb.fedex.estimatedCost',{defaultValue:'预估费用'}),
				key: "estimatedCost",
				width: '23%',
			}, {
				title: this.$t('erp.product_channel.currency',{defaultValue:'币种'}),
				key: "currency",
				width: '23%',
			}]
		},
        columns() {
			return [
			{
				// title:"承运商",
				type: 'expand',
				width: '8%',
				renderExpand:(h,{row})=>{
					return <vTableSimple border style="height: initial;" columns={this.getExpandColumns} showThead={false} data={row.calculationCostItems||[]} noDataText={'<div class=color-error>'+row.message+'</div>'}/>
				}
			},
			{
				title: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
				key: "account",
				width: this.coltype=='costcacl'?'17%':0
			},
			{
				title: this.$t('fbb.alloment.carrier_code',{defaultValue:'物流商'}),
				key: "groupName",
				width: this.coltype=='costcacl'?'20%':'23%',
			}, {
				title: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流商服务'}),
				key: this.coltype=='costcacl'?"carrierServiceCode":"carrierServiceName",
				width: this.coltype=='costcacl'?'20%':'23%',
			}, {
				title: this.$t('fbb.fedex.estimatedCost',{defaultValue:'预估费用'}),
				key: "estimatedCost",
				width: this.coltype=='costcacl'?'20%':'23%',
				sortable:true,
				sync:true
			}, {
				title: this.$t('erp.product_channel.currency',{defaultValue:'币种'}),
				key: "currency",
				width: this.coltype=='costcacl'?'15%':'23%',
			}]
		}
    }
}
</script>
